$(function () {

    $(document).ready(function(){

        $.fn.select2.defaults.set("minimumResultsForSearch", 10);

        var url = window.location.origin;

        var commonProcessing = function (data, params, displayColumn) {
          displayColumn = typeof displayColumn !== 'undefined' ? displayColumn: 'name'

          params.page = params.page || 1;

            if(data.data){
                return {
                    results: $.map(data.data, function (item) {
                        return {
                            text: item[displayColumn] + ' (ID:' + item.id + ')',
                            slug: item.locale,
                            id: item.id
                        }
                    }),
                    pagination: {
                        more: data.to < data.total
                    }
                };
            }
            else{
                return {
                    results: $.map(data, function (item) {
                        return {
                            text: item[displayColumn],
                            slug: item.locale,
                            id: item.id
                        }
                    }),
                    pagination: {
                        more: data.to < data.total
                    }
                };
            }
        };

        $('.js-select2').select2();

        var initAutocompleter = function (selector, endpoint, filterObject, displayColumn, allowClear) {
            allowClear = typeof allowClear !== 'undefined' ? allowClear : true
            filterObject = typeof filterObject !== 'undefined' ? filterObject: { type: 'search', column: 'name'}
            displayColumn = typeof displayColumn !== 'undefined' ? displayColumn: 'name'

            $(selector).select2({
              allowClear: allowClear,
              ajax: {
                url: endpoint,
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                  var searchObject = {
                      search: {},
                      filter: {},
                      page: {}
                  }


                  searchObject[filterObject['type']][filterObject['column']] = params.term
                  searchObject['page'] = params.page
                  return searchObject;
                },
                processResults: function (data, params) {
                  return commonProcessing(data, params, displayColumn);
                },
                cache: true
              }
            })
        }

        initAutocompleter('.js-master--universities', '/master/universities')
        initAutocompleter('.js-master--access-student-students', '/master/universities')
        initAutocompleter('.js-master--students', '/alumnos/list', { type: 'filter', column: 'id'})
        initAutocompleter('.js-master--partner-universities', '/beuniversity/partner-universities/select')
        initAutocompleter('.js-master--product-type', '/master/products-types')
        initAutocompleter('.js-master--landings', '/landings/list-select', { type: 'filter', column: 'id'}, 'title');
        initAutocompleter('.js-master--countries', '/master/countries', { type: 'filter', column: 'id'}, 'title');
        initAutocompleter('.js-master--sectors', '/sectors/list-select', { type: 'filter', column: 'id'}, 'title');
        initAutocompleter('.js-master--categories', '/categories/list-select', { type: 'filter', column: 'id'}, 'title');
        initAutocompleter('.js-master--business-unit', '/master/business-units');
        initAutocompleter('.js-master--companies-sizes', '/master/company-sizes', { type: 'filter', column: 'id'}, 'size');
        initAutocompleter('.js-master--beuniversity-admin-sections', '/master/beuniversity-admin-sections', { type: 'filter', column: 'id'}, 'name');
        initAutocompleter('.js-master--jobs-status', '/master/job-status', {type: 'filter', column: 'status'}, 'status');
        initAutocompleter('.js-master--beuniversity-role', '/master/beuniversity-admin-roles', {type: 'filter', column: 'name'}, 'name');
        initAutocompleter('.js-master--offers', '/ofertas/select', { type: 'filter', column: 'id'}, 'name');
        initAutocompleter('.js-master--customizations', '/customizaciones/autocompleted-list', { type: 'search', column: 'description'}, 'description');
        initAutocompleter('.js-master--field-groups', '/dynamic-fields/field-groups/en', {type: 'filter', column: 'dynamic_field_groups.id'}, 'name');
        initAutocompleter('.js-master--fields', '/dynamic-fields/fields/en', {type: 'filter', column: 'dynamic_fields.id'}, 'name');

      $('.js-languages-select').select2({
            theme: 'foundation',
            minimunInputLenght: 0,
            minimumResultsForSearch: 2000,
            ajax: {
                url: url + "/master/languages/es",
                dataType: 'json',
                delay: 250,
                processResults: function (data, params) {
                    return {
                        results: $.map(data.data, function(dataItem) {
                            return { id: dataItem.id, text: dataItem.name };
                        })
                    };
                },
                cache: true
            },
            escapeMarkup: function (markup) { return markup; }, // let our custom formatter work
            minimumInputLength: 1
        });

        $('.js-master--annexes-statuses').select2({
            allowClear: true,
            ajax: {
                url: url + '/gestion-de-convenios/estados-de-anexos',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {
                    return commonProcessing(data, params);
                },
                cache: true
            }
        });

        $('.js-master--annexes-renewals-statuses').select2({
            allowClear: true,
            ajax: {
                url: url + '/gestion-de-convenios/estados-de-renovaciones',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {
                    return commonProcessing(data, params);
                },
                cache: true
            }
        });

        $('.js-master--languages').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/languages',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {
                    return commonProcessing(data, params);
                },
                cache: true
            }
        });

        $('.js-master--language-levels').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/languages-level',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {
                    return commonProcessing(data, params);
                },
                cache: true
            }
        });

        $('.js-master--sectors').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/sectors',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {
                    return commonProcessing(data, params);
                },
                cache: true
            }
        });

        $('.js-master--categories').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/categories',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {
                    return commonProcessing(data, params);
                },
                cache: true
            }
        });

        $('.js-master--group-studies').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/group-studies',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params){
                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name + ' (ID:' + item.id + ')',
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: params.page < data.last_page
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: params.page < data.last_page
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--campaigns').select2({
            allowClear: true,
            ajax: {
                url: url + '/alumnos/campaigns',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {campaign:params.term}, // search term
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.campaign,
                                    slug: item.campaign,
                                    id: item.campaign
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.campaign,
                                    slug: item.campaign,
                                    id: item.campaign
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        })

        $('.js-master--com-types').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/company-types',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.type,
                                    slug: item.type,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.type,
                                    slug: item.type,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--com-sizes').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/company-sizes',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.size,
                                    slug: item.size,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.size,
                                    slug: item.size,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--offer-status--company').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/offer-status',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.size,
                                    slug: item.size,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.id,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--contract-kinds').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/contract-kinds',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--workschedule-types').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/workschedule-types',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

      $('.js-master--job-offer-areas').select2({
        allowClear: true,
        ajax: {
          url: url + '/master/job-offer-areas',
          dataType: 'json',
          delay: 250,
          method: 'GET',
          async: false,
          data: function (params) {
            return {
              search: {name:params.term}, // search term
              page: params.page
            };
          },
          processResults: function (data, params) {

            params.page = params.page || 1;

            if(data.data){
              return {
                results: $.map(data.data, function (item) {
                  return {
                    text: item.name,
                    slug: item.name,
                    id: item.id
                  }
                }),
                pagination: {
                  more: (params.page * 30) < data.total
                }
              };
            }
            else{
              return {
                results: $.map(data, function (item) {
                  return {
                    text: item.name,
                    slug: item.name,
                    id: item.id
                  }
                }),
                pagination: {
                  more: (params.page * 30) < data.total_count
                }
              };
            }
          },
          cache: true
        }
      });

        $('.js-master--user-type').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/user-types',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--fp-studies').select2({
            allowClear: true,
            ajax: {
                url: '/master/fp-studies',
                dataType: 'json',
                delay: 250,
                method: 'GET',async: false,
                allowClear: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            },
            language: {
                noResults: function(term) {
                    var locale = window.beWanted.locale.currentLocale
                    if(Plugin.groups){
                        var val = $('.select2-search').val();
                        $('.select2-results').css('cursor','pointer');
                        $('.select2-results').on('mouseover',function(){
                            $('.select2-results').css('color','#1D9ED3');
                        });
                        $('.select2-results').on('mouseout',function(){
                            $('.select2-results').css('color','#6A7480');
                        });
                        $('.select2-results').on('click',function(){
                            Plugin.studies.select2('close');
                            Plugin.newStudy();
                        });
                        return Plugin.groups.attr('data-noResults');
                    }else if(locale == 'es' || locale == 'mx') {
                        $('.select2-results').unbind('click')
                        return 'Sin resultados';
                    }else if(locale == 'en'){
                        $('.select2-results').unbind('click')
                        return 'Without results';
                    }else if(locale == 'pt'){
                        $('.select2-results').unbind('click')
                        return 'Nenhum resultado';
                    }
                }
            }
        });

        $('.js-master--nationalities').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/nationalities',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--countries').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/countries',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--cities').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/cities',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--states').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/states',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--studies').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/studies',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--news').select2({
            allowClear: true,
            minimumResultsForSearch: 1,
            ajax: {
                url: url + '/noticias/select',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {'name':params.term}, // search term
                        column:'id',
                        order:'desc',
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text:  item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });
        $('.js-master--group-news').select2({
            allowClear: true,
            minimumResultsForSearch: 1,
            ajax: {
                url: url + '/grupo-noticias/select',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {'name':params.term}, // search term
                        column:'id',
                        order:'desc',
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text:  item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--landings-url-val').select2({
            allowClear: true,
            minimumResultsForSearch: 1,
            ajax: {
                url: url + '/landings/list-select',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {'slug':params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text:  item.dynamic_page.slug,
                                    id: item.dynamic_page.slug
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.url,
                                    id: item.url
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--evps').select2({
            allowClear: true,
            minimumResultsForSearch: 1,
            ajax: {
                url: url + '/evps/list-select',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {'slug': params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text:  item.dynamic_page.slug,
                                    id: item.dynamic_page.slug
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.dynamic_page.slug,
                                    id: item.dynamic_page.slug
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });



        $('.js-orders--origins').select2({
            allowClear: true,
            ajax: {
                url: url + '/pedidos/origenes',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-orders--products').select2({
            allowClear: true,
            ajax: {
                url: url + '/productos/list',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-order--origin').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/order-origin',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-order--status').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/order-status',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-invoice--status').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/invoice-status',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-orders--payments').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/payment-methods',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-autocomplete-products').select2({
            allowClear: true,
            ajax: {
                url: url + '/productos/list',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        queries: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                if(item.job_offer_packages[0]){
                                    var text = item.reference + ' - ' + item.name + ' - ' + item.price + ' - Incluye ' + item.job_offer_packages[0].job_offers_amount + ' Procesos';
                                } else {
                                    var text = item.reference + ' - ' + item.name + ' - ' + item.price;
                                }
                                return {
                                    text: text,
                                    slug: item.locale,
                                    id: item.id,
                                    price: item.price,
                                    mxPrice: item.mx_price
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-autocomplete-job-offer-packages').select2({
            allowClear: true,
            ajax: {
                url: url + '/paquetes-de-ofertas/list',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: 'Paquete ID: ' + item.id + ' - ' + item.job_offers_amount + ' Procesos incluidos - ' + item.description,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--company').select2({
            allowClear: true,
            ajax: {
                url: url + "/empresas/autocompleted-list",
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name + ' (ID:' + item.id + ')',
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--company-user-roles').select2({
            allowClear: true,
            ajax: {
                url: url + "/master/company-user-roles",
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });
        $('.js-master--company-panel-sections').select2({
            allowClear: true,
            ajax: {
                url: url + "/master/company-panel-sections",
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-autocomplete-taxes').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/taxes',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.tax,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.tax,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-autocomplete-modules').select2({
            allowClear: true,
            ajax: {
                url: url + '/modules/list',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-autocomplete-templates').select2({
            allowClear: true,
            ajax: {
                url: url + '/templates/list',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-autocomplete-taxes').select2({
            allowClear: true,
            ajax: {
                url: url + '/master/taxes',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.tax,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.tax,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-autocomplete-pages_second_level').select2({
            allowClear: true,
            ajax: {
                url: url + '/paginas/second-level',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {title:params.term}, // search term
                        page: params.page,
                        locale: $('[name=locale]').val(),
                        is_candidate_page: $('[name=is_candidate_page]').val()
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.second_template.commercial_title,
                                    id: item.second_template.page_id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.second_template.commercial_title,
                                    id: item.second_template.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-autocomplete--company').autocompleter({
            source: url + "/empresas/list",
            minLength: 2,
            customLabel: 'name',
            customValue: 'id'
        });


        $('.js-autocomplete--themes').select2({
            allowClear: true,
            ajax: {
                url: url + '/themes/list',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    return {
                        results: $.map(data.data, function (item) {
                            return {
                                text: item.name,
                                slug: item.locale,
                                id: item.id
                            }
                        }),
                        pagination: {
                            more: (params.page * 15) < data.total
                        }
                    };
                },
                cache: true
            }
        });

        $('.js-master--blog-categories').select2({
            allowClear: true,
            minimumResultsForSearch: 1,
            ajax: {
                url: url + '/blog/categorias/select',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {'name':params.term}, // search term
                        column:'id',
                        order:'desc',
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text:  item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--blog-authors').select2({
            allowClear: true,
            minimumResultsForSearch: 1,
            ajax: {
                url: url + '/blog/autores/select',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {'name':params.term}, // search term
                        column:'id',
                        order:'desc',
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text:  item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 15) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--blog-banner-positions').select2({
            allowClear: true,
            ajax: {
                url: url + '/blog/banners/select-positions',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {description:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.description,
                                    slug: item.description,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.description,
                                    slug: item.description,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        $('.js-master--blog-featured-news-modules').select2({
            allowClear: true,
            ajax: {
                url: url + '/blog/featured-modules/select',
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {description:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.description,
                                    slug: item.description,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.description,
                                    slug: item.description,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });


    });

});
